"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusHistoryChart = void 0;
var react_1 = __importDefault(require("react"));
var MultiMetricStacked_1 = __importDefault(require("@CommonFrontend/Charts/BarChart/MultiMetricStacked"));
var Types_1 = require("Reports/Types");
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
var CalculateTimePeriod_1 = require("Reports/Utils/CalculateTimePeriod");
var DateConverter_1 = require("Reports/Utils/DateConverter");
var FormatCurrency_1 = require("@CommonFrontend/Utils/FormatCurrency");
var tokens_1 = require("@qwilr/kaleidoscope/tokens");
var Colors = {
    draft: tokens_1.palette.grey900,
    live: tokens_1.palette.orange300,
    accepted: tokens_1.palette.green300,
    declined: tokens_1.palette.red300,
};
function StatusHistoryChart(_a) {
    var _b, _c;
    var data = _a.data, granularity = _a.granularity, filters = _a.filters, selectedTimePeriod = _a.selectedTimePeriod, selectedCurrency = _a.selectedCurrency;
    if ((0, isEmpty_1.default)(data) || (0, isEmpty_1.default)(filters))
        return null;
    var _d = __read(filters, 1), selectedStatusHistoryFilter = _d[0];
    var adjustedData = getDataForStatusHistoryChart(data, granularity, selectedStatusHistoryFilter, selectedTimePeriod);
    var YAXIS_FORMATTER = (_b = {},
        _b[Types_1.SelectedStatusHistoryFilter.Count] = function (value) { return String(value); },
        _b[Types_1.SelectedStatusHistoryFilter.Value] = function (value) { return (0, FormatCurrency_1.formatAbbreviatedCurrency)(value, selectedCurrency, 1, true); },
        _b);
    var YAXIS_LABEL = (_c = {},
        _c[Types_1.SelectedStatusHistoryFilter.Count] = "Page count",
        _c[Types_1.SelectedStatusHistoryFilter.Value] = "Page value (".concat(selectedCurrency, ")"),
        _c);
    var config = {
        yAxis: {
            label: YAXIS_LABEL[selectedStatusHistoryFilter],
            tickFont: tokens_1.tokens.font.ui,
            tickLetterSpacing: "1px",
            tickColor: tokens_1.tokens.color.textSecondary,
            tickFormatter: YAXIS_FORMATTER[selectedStatusHistoryFilter],
        },
    };
    return react_1.default.createElement(MultiMetricStacked_1.default, { data: adjustedData, colors: Colors, config: config });
}
exports.StatusHistoryChart = StatusHistoryChart;
function getDataForStatusHistoryChart(data, granularity, filter, selectedTimePeriod) {
    var periodStart = (0, CalculateTimePeriod_1.calculateTimePeriod)(selectedTimePeriod).periodStart;
    var selectedPeriodStartLabel = (0, DateConverter_1.getChartDateLabel)(periodStart, granularity);
    return data.map(function (statusHistory) {
        var time = statusHistory.time, metrics = statusHistory.metrics;
        var pageStatusMetrics = metrics.pageStatusMetrics;
        var xAxisName = (0, DateConverter_1.getChartDateLabel)(time, granularity);
        return {
            xAxisName: xAxisName,
            draft: pageStatusMetrics.draft["total".concat(filter)],
            live: pageStatusMetrics.live["total".concat(filter)],
            accepted: pageStatusMetrics.accepted["period".concat(filter)],
            declined: pageStatusMetrics.declined["period".concat(filter)],
            isSelected: xAxisName === selectedPeriodStartLabel,
        };
    });
}
